<template>
  <div class="background-gradient">
    <canvas ref="backgroundElement" class="background-gradient__canvas" />
    <slot></slot>
  </div>
</template>

<script setup>
import { onMounted, watch, ref, toRefs } from 'vue';
import { Gradient } from '@/shared/js/modules/gradient';

const props = defineProps({
  colors: {
    type: Array,
    default: () => [],
  },
});

const { colors } = toRefs(props);

const backgroundElement = ref(null);

onMounted(() => {
  const gradient = new Gradient();
  gradient.initGradientWithElement(backgroundElement.value, colors.value);

  watch(colors, colors => {
    gradient.updateColors(colors);
  });
});
</script>
